import { useTranslation } from 'react-i18next';
import { Button, Spin } from 'antd';
import { CheckCheck, Inbox } from 'lucide-react';
import { NotificationItem } from './NotificationItem';
import type { AppNotification, NotificationFeed } from '../types';

interface NotificationPanelProps {
  feed?: NotificationFeed;
  loading: boolean;
  error: boolean;
  markingAll: boolean;
  onSelect: (item: AppNotification) => void;
  onMarkAll: () => void;
}

/** Zil dropdown içeriği: başlık + "tümünü okundu" + liste / boş / yükleniyor / hata. */
export function NotificationPanel({
  feed,
  loading,
  error,
  markingAll,
  onSelect,
  onMarkAll,
}: NotificationPanelProps) {
  const { t } = useTranslation('notifications');
  const items = feed?.items ?? [];
  const unreadCount = feed?.unreadCount ?? 0;

  return (
    <div className="ds-notif-panel" data-testid="notification-panel">
      <div className="ds-notif-panel__head">
        <span className="ds-notif-panel__title">{t('panel.title')}</span>
        <Button
          type="text"
          size="small"
          icon={<CheckCheck size={14} strokeWidth={1.8} />}
          disabled={unreadCount === 0 || markingAll}
          loading={markingAll}
          onClick={onMarkAll}
          data-testid="notification-mark-all"
        >
          {t('panel.markAll')}
        </Button>
      </div>

      <div className="ds-notif-panel__list">
        {loading && items.length === 0 ? (
          <div className="ds-notif-panel__state">
            <Spin size="small" />
          </div>
        ) : error && items.length === 0 ? (
          <div className="ds-notif-panel__state ds-notif-panel__state--error">
            {t('panel.error')}
          </div>
        ) : items.length === 0 ? (
          <div className="ds-notif-panel__empty" data-testid="notification-empty">
            <Inbox size={28} strokeWidth={1.4} />
            <span>{t('panel.empty')}</span>
          </div>
        ) : (
          items.map((item) => (
            <NotificationItem key={item.id} item={item} onSelect={onSelect} />
          ))
        )}
      </div>
    </div>
  );
}
